<template>
  <a-modal
    title="数据统计"
    :visible="showTubeView"
    width="80%"
    destroyOnClose
    @ok="closeTubeView"
    @cancel="closeTubeView"
    style="position: absolute; left: 18rem; z-index: 999; top: 3rem"
  >
    <a-button
      type="primary"
      style="margin-bottom: 8px"
      @click="exportHandle()"
      :loading="exportLoading"
    >导出</a-button>
    <a-table rowKey="id" :data-source="dataList" :columns="columns" :loading="dataListLoading" :pagination='false'>
      <!-- <a-tag color="blue" slot="waterBigStatus" slot-scope="text">{{ text === 1 ? '用水大户' : '普通用户' }}</a-tag> -->
      <!-- <span slot="createTime" slot-scope="text">{{ moment(text).format("YYYY-MM-DD")}}</span> -->
      <!-- <span slot="action" slot-scope="text, record">
        <a @click="jumpFather(record)">跳转</a>
      </span>-->
    </a-table>
  </a-modal>
</template>
<script>
import request from '@/utils/request'
import axios from 'axios'
import moment from 'moment'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'
export default {
  data() {
    return {
      columns: [
        {
          title: '特征点',
          dataIndex: 'featurePoint'
        },
        {
          title: '个数',
          dataIndex: 'num'
        }
      ],
      queryUrl: '/pipe-network/pipes/region/statistics',
      dataList: [],
      dataListLoading: false,
      exportLoading: false,
      //   pagination: {
      //     current: 1,
      //     pageSize: 10,
      //     total: 0,
      //     showTotal: total => `共 ${total} 条记录`,
      //     showSizeChanger: true,
      //     pageSizeOptions: ['10', '20', '50', '100']
      //   },
      exportFileName: '数据统计.xlsx',
      exportDataUrl: 'pipe-network/pipes/export/region/statistics',
      showTubeView: false,
      arr: []
    }
  },
  methods: {
    moment,
    // 导出
    exportHandle() {
      this.exportLoading = true
      const token = storage.get(ACCESS_TOKEN)
      const params = {
          linestring: this.arr
      }
       const params2 = {
        responseType: 'arraybuffer',
        headers: {
          Authorization: token
        }
      }
      const url = `${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`
      axios
        .post(url, params,params2).then(res => {
          
          const blob = new Blob([res.data], { type: 'application/octet-stream;charset=utf-8' })
          const fileName = this.exportFileName || '导出数据.xlsx'
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)
          this.$message.success('导出完成')
          this.exportLoading = false
        })
        .catch(() => {
          this.exportLoading = false
        })
    },
    // pageChange(pagination, filters, sorter) {
    //   this.pagination.current = pagination.current
    //   this.pagination.pageSize = pagination.pageSize
    //   this.getDataList()
    // },
    edit(arr) {
      this.showTubeView = true
      if (arr) {
        this.arr = arr
        this.getDataList()
      }
    },

    //获取数据
    getDataList() {
      this.dataListLoading = true
      let params = {
        linestring: this.arr
      }
      this.$http
        .post(this.queryUrl, params)
        .then(({ data }) => {
          
          this.dataListLoading = false
          this.dataList =data || []
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    closeTubeView() {
      this.showTubeView = false
    }
  }
}
</script>

<style lang="less" scoped>
</style>
